module.exports = __webpack_public_path__ + "img/nao-encontrado-desk.d1ec928b.png";